var vga = "https://shopfront-cdn.tekoapis.com/static/a54a3adf0f0f78ab.svg";

export { vga as default };
